import { useNavigate } from "@tanstack/react-router";
import { Button } from "@workspace/web-ui/components/button";
import { Card } from "@workspace/web-ui/components/card";
import { Image } from "@workspace/web-ui/components/image";
import SuccessIcon from "~/assets/icons/success-icon.svg";

interface SuccessPageProps {
  type: "reset" | "update";
}

const SuccessPage = ({ type }: SuccessPageProps) => {
  const navigate = useNavigate()
  const isReset = type === "reset";


  const redirectToLogin = (type: string) => {
    if (type === "reset") {
      navigate({ to: "/", replace: true })
    } else {
      navigate({ to: "/dashboard" })
    }
  }

  return (
    <Card className="max-w-[550px] flex flex-col gap-4 justify-center items-center w-full p-[32px] rounded-[10px] shadow-lg">
      <Image src={SuccessIcon} alt="Success" className="w-16 h-16" layout="constrained" width={96} height={96} />
      <h1 className="text-3xl font-medium break-words text-center">
        {isReset ? "Password Reset Link Sent Successfully!" : "Password Updated Successfully!"}
      </h1>
      <p className="text-base font-normal text-gray-500 break-words text-center">
        {isReset
          ? "We've sent a password reset link to your email address. Please check your inbox and follow the instructions to reset your password."
          : "You have successfully updated your password. Your new password is secure and will help protect your account from unauthorized access."}
      </p>

      <Button className="px-[16px] py-[12px] h-10 rounded-[10px] w-[40%] bg-[#4272DD]" onClick={() => redirectToLogin(type)}>
        {isReset ? "Back to Login" : "Continue to Dashboard"}
      </Button>
    </Card>
  );
};

export default SuccessPage;
